import React from "react";
import Footer from "../layouts/footer";
import TitleAndMetaTags from "../components/TitleAndMetaTags";

const NotFoundPage = () => (
  <div className="four-oh-four-page page-wrap">
    <TitleAndMetaTags title={"Aaron Ong - Full Stack Developer"} />
    <h1 className="page-title">404</h1>
    <div className="page-content">
      <p>You just hit a route that doesn&#39;t exist... the sadness :</p>
    </div>
    <Footer />
  </div>
);

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/pages/404.js